export default __webpack_public_path__ + "static/media/envoyer-emial.7c8dd914.svg";